/**
 * Tarih secici <-> form state donusumleri.
 *
 * Uygulamadaki tum form alanlari tarihi `yyyy-MM-dd` string'i olarak tutar
 * (native <input type="date"> ile ayni sekil). AppDatePicker bu yardimcilarla
 * calistigi icin native input'tan gecis yapan ekranlarda state tipi degismez.
 *
 * KRITIK: Date <-> string donusumu YEREL saat bilesenleriyle yapilir.
 * toISOString() kullanilirsa UTC'ye kayma olur ve GMT+3'te secilen gun
 * bir onceki gune duser.
 */

/** `yyyy-MM-dd` (veya ISO datetime) string'ini yerel Date'e cevirir. */
export function parseDateInput(value?: string | null): Date | null {
  if (!value) return null;

  const trimmed = String(value).trim();
  if (!trimmed) return null;

  // `2026-08-18` ve `2026-08-18T10:30:00Z` — her ikisinde de yalniz tarih kismi kullanilir.
  const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const parsed = new Date(year, month - 1, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const fallback = new Date(trimmed);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

/**
 * Date'i `yyyy-MM-dd` string'ine cevirir.
 * Bos ya da yarim girilmis (Invalid Date) degerler icin bos string doner —
 * native input'un davranisiyla ayni.
 */
export function formatDateInput(date: Date | null | undefined): string {
  if (!date || Number.isNaN(date.getTime())) return '';

  const year = String(date.getFullYear()).padStart(4, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
